if (typeof(window.ABR) !== 'object') {
	window.ABR = {};
}

window.ABR.RaceSchedule = {
	Collections: require('./store/Collections').default,
	Models: require('./store/Models').default
};

import Vue from 'vue';
import store from './vuex/store';
import App from './components/App.vue';
import ABRVue from './../common/ABRVue.js';
import VueTouch from 'vue-touch';

Vue.use(ABRVue);
Vue.use(VueTouch);

if (__DEV__) {
	console.log('env: dev');
	Vue.config.debug = true;
}

Vue.filter('numeric', function (value) {
	return value.replace(/\D+$/g, "");
});

new Vue({
	store,
	el: '#race-schedule',
	components: { App }
});



/** WEBPACK FOOTER **
 ** ./site/sites/all/themes/custom/abr_theme/js/race-schedule/main.js
 **/